export type TCustomiseLabelsRule = {
    type: "some-enabled";
    groupId: string;
};

export type TCustomiseLabelsOption = {
    id: string;
    label: string;
    rules?: readonly TCustomiseLabelsRule[];
};

const tenurePersonLabelRule: TCustomiseLabelsRule = {
    type: "some-enabled",
    groupId: "roles-names",
};

// as const tells TS this is a tuple and not simply { id: string, label: string }[]
export const customiseLabelsOptions = [
    {
        id: "show-roles",
        label: "Show Roles",
        rules: [tenurePersonLabelRule],
    },
    {
        id: "show-names",
        label: "Show Names",
        rules: [tenurePersonLabelRule],
    },
    {
        id: "reveal-labels",
        label: "Reveal Labels Not Shown",
    },
    {
        id: "show-experience-region",
        label: "Experience region",
    },
    {
        id: "show-typical-archetype-location",
        label: "Typical Archetype Locations",
    },
] as const;

// Getting an Union of the ids from options
export type TOptionsIds = typeof customiseLabelsOptions[number]["id"];

export type TCustomiseLabelsOptions = { [K in TOptionsIds]?: boolean };
